import { render, staticRenderFns } from "./vSolicitudes.vue?vue&type=template&id=727e52d4&scoped=true"
import script from "./vSolicitudes.vue?vue&type=script&lang=js"
export * from "./vSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./vSolicitudes.vue?vue&type=style&index=0&id=727e52d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e52d4",
  null
  
)

export default component.exports